<!--
  InFlightOrdersNotice.vue -- Phase 4.6 in-flight orders surface.

  Card: 2026-06-13 design bundle implementation -- https://trello.com/c/hYlwyKYT
  Pebble: Phase 4.6 BulkApplySetModal (full UI).

  P4-Q16: surface that M of the selected products have orders that have
  NOT yet shipped/canceled. Bulk-apply will NOT retroactively touch
  these orders -- the existing line items keep their snapshot. The
  notice exists so the operator knows pending fulfilment is unchanged.

  Renders nothing when count === 0.
-->
<template>
    <div
        v-if="count > 0"
        class="in-flight-orders-notice"
        data-testid="in-flight-orders-notice"
    >
        <strong>{{ count }}</strong>
        {{ count === 1 ? 'product has' : 'products have' }}
        in-flight orders -- unchanged.
    </div>
</template>

<script>
export default {
    name: 'InFlightOrdersNotice',
    props: {
        count: {
            type: Number,
            required: true,
            default: 0,
        },
    },
}
</script>

<style scoped>
.in-flight-orders-notice {
    padding: 8px 12px;
    background: #eff6ff;
    border-left: 3px solid #3b82f6;
    border-radius: 4px;
    font-size: 13px;
    color: #1e3a8a;
}
</style>
